<template>
    <v-dialog v-on="$listeners" :value="value" :persistent="m_options.persistent" :width="m_options.width">
        <v-card>
            <v-card-title class="cabecalho pt-0">
                <button v-if="m_options.showCloseButton" class="close-button" @click="dismiss()"><v-icon>close</v-icon></button>
                <slot name="title"><span>{{ m_options.title }}</span></slot>
            </v-card-title>
            <v-flex :style="max_height" id="content">
                <slot v-if="!m_options.transformInHtml">
                    <pre class="dialog-text">{{ m_options.text }}</pre>
                </slot>
                <slot v-else>
                    <pre v-html="m_options.text"></pre>
                </slot>
            </v-flex>
            <v-card-actions :class="{ 'centralize_button': centralizeButton }">
                <slot name="buttons">
                    <v-spacer></v-spacer>
                    <div ref="alert_actions" class="alert_actions">
                        <v-btn class="btn-default"
                               :data-tipo="btn.text || text"
                               id="ButtonDialog"
                               :key="i"
                               v-for="(btn, text, i) in m_options.buttons"
                               :autofocus="btn.focus"
                               :class="btn.focus ? 'focus' : ''"
                               :color="btn.color || (i === Object.keys(m_options.buttons).length - 1 ? 'primary' : 'secondary')"
                               :disabled="!!btn.disabled"
                               @click="handle(btn)">
                            {{ btn.text || text }}
                        </v-btn>
                    </div>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import { isObject } from '../plugins/helpers'
  import { isString, isUndefined, omitBy, pick } from 'lodash'

  const defaultOptions = {
    title: 'Atenção!',
    text: '',
    buttons: {},
    persistent: true,
    showCloseButton: false,
    transformInHtml: false,
    width: 500
  }

  export default {
    name: 'Dialog',
    props: {
      title: String,
      value: Boolean,
      options: [Object, String],
      showCloseButton: Boolean,
      hideButtons: Boolean,
      transformInHtml: { Boolean, default: false },
      unlimitHeight: { Boolean, default: false }
    },
    data () {
      return {
        centralizeButton: false
      }
    },
    computed: {
      max_height () {
        return this.unlimitHeight ? { 'max-height': 'none' } : ''
      },
      m_options () {
        let options = this.options

        if (isString(options)) {
          options = {
            text: options, buttons: { 'OK': { focus: true } }
          }
        }
        const keys = Object.keys(defaultOptions)
        // O omitBy serve para remover as props sem valor default
        options = { ...defaultOptions, ...pick(this.$attrs, keys), ...omitBy(pick(this.$props, keys), isUndefined), ...options }

        if (this.hideButtons) {
          options.buttons = null
        }

        if (options.buttons) {
          Object.keys(options.buttons).forEach(key => {
            let btn = options.buttons[key]

            if (!isObject(btn)) {
              btn = options.buttons[key] = {
                handler: btn
              }
            }

            if (!btn.handler) {
              btn.handler = () => true
            }
          })
        }
        if (options.centralizeButton) {
          this.centralizeButtonMethod(options.centralizeButton)
        }
        return options
      }
    },
    watch: {
      value (visible) {
        const actions = this.$refs.alert_actions
        if (visible && actions) {
          this.$nextTick(() => {
            const el = actions.querySelector('.focus')
            if (el) {
              el.focus()
            }
          })
        }
      }
    },
    methods: {
      centralizeButtonMethod (centralize) {
        this.centralizeButton = centralize
      },
      dismiss () {
        this.$emit('input', false)
      },
      handle (h) {
        if (h && h.handler(this) !== false) {
          this.dismiss()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .cabecalho {
        justify-content: flex-end;
        padding: 0 0 12px;
        margin: 12px;
        border-bottom: solid 1px var(--lightgray);

        span {
            width: 100%;
            font-size: 1.2rem;
            text-transform: uppercase;
            color: var(--secondary);
            text-align: center;
        }
    }

    #content {
        max-height: 350px;
        overflow-y: auto;
        padding: 0 8px;

        pre {
            padding: 8px 0;
            color: var(--dark);
            white-space: pre-wrap;
        }
    }

    .v-card {
        padding: 5px;
    }

    .alert_actions .v-btn {
        width: auto !important;
        min-width: 120px !important;
    }

    .close-button {
        position: absolute;
        top: 8px;
        right: 12px;
        outline: none;
    }

    .centralize_button{
        display:flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
</style>
